import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DataMessageService } from '../service/data-message.service';
import { AbstractModal, ModalButtonModel, ModalButtonType, ToasterType, BroadcastService} from '@cv-invision/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';

@Component({
    template: ''
})

export abstract class CreateUpdateComponent extends AbstractModal implements OnInit, OnDestroy {
    protected atComponentDestroy = new Subject();
	protected dataMessageConfiguration: any;
    public saving: boolean = false;
	public config: any;
	public originalConfig: any;

    constructor(
		public dataMessageService: DataMessageService,
		public broadcastService: BroadcastService,
		public store: Store
	) {
		super();
	}

    ngOnInit(): void {

		if (this.data.isEditing) {
			this.config = { ...this.data.dataMessage };
			this.originalConfig = { ...this.data.dataMessage };
		}

		this.dataMessageService
			.getDataMessageConfiguration()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				result => {
					if (result) {
						this.dataMessageConfiguration = result;
					}
				},
				error => console.error(error)
			);

        const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};
		const confirmButton: ModalButtonModel = {
			name: 'save',
			text: 'Save',
			class: 'btn-sm cv-btn-blue ',
			type: ModalButtonType.ACTION,
			disabled: (): boolean => !this.setIsFormValid() || this.saving,
			action: () => this.onSave(),
			loading: (): boolean => this.saving,
			loadingText: 'Saving'
		};

		this.buttons.push(cancelButton);
		this.buttons.push(confirmButton);
    }

    /**
	 * Is form valid?
	 */
	setIsFormValid(): boolean {
		return true;
	}

	/**
	 * Is organization data dirty?
	 */
	isDirty(): boolean {
		return JSON.stringify(this.originalConfig) !== JSON.stringify(this.config);
	}

    /**
	 * On Save button.
	 */
	onSave(): void {

		if (this.data.isEditing) {
			const editConfig = { ...this.config };
			delete editConfig.id;
			this.dataMessageConfiguration[this.config.id] = editConfig;
		} else {
			this.dataMessageConfiguration.push(this.config);
		}
		
		this.dataMessageService
			.updateDataMessageConfiguration(this.dataMessageConfiguration)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				response => {
					if (response.succeeded) {
						this.successHandleFunction();
						super.onAcceptSuccess({
							success: true
						});
					}
				},
				error => {
					this.errorMsgFunction(error.error.error);
				}
			);
	}

	/**
	 * handle response from server
	 */
	successHandleFunction(): void {
		const msgSuget = this.data.isEditing ? 'Updated' : 'Created';
		const msg = `The Data Message Type Configuration Was ${msgSuget} Successfully`;
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: { message: msg }
		});
	}

	/**
	 * Display error message if the operation was not success
	 * @param error
	 */
	errorMsgFunction(error: string): void {
		this.broadcastService.broadcast({
			name: ToasterType.ERROR,
			event: { error }
		});
	}

    ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	onDismiss(): void {
		super.onCancel();
	}
}